import {BaseModel} from "./Base";

    export interface IAddress {
      key: string,
      address: string,
      zipcode: string,
      residence: string,
    }
    
export class AddressModel extends BaseModel implements IAddress  {
key: string;
address: string = "";
zipcode: string = "";
residence: string = "";

    constructor(data = null) {
        super();
        if(data) {
            this.syncData(data);
        }
    }      

      public syncData(data) {
            if(data) {
                Object.keys(data).map((item) => {
                        this[item] = data[item];
                });
            }
      }

  
}